import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Box,
} from "@mui/material";
import {
  ExpandMore,
  FlagOutlined,
  StarOutlined,
  ImportExportOutlined,
  FormatListNumberedOutlined,
  MapOutlined,
  TravelExploreOutlined,
  PlayCircleOutline,
} from "@mui/icons-material";
import useStyles from "../Games/styles";

const Help = () => {
  const classes = useStyles();
  const games = [
    {
      name: "Flags",
      summary: "Given a flag - guess the correct country",
      description:
        "Select the region of the world, the number of questions, and the game mode you prefer. Multiple Choice: Given a flag and 4 countries from that region, select the correct country. Type Answer: Given a flag, type the correct country that the flag belongs to",
      link: "/flags",
      icon: (
        <FlagOutlined
          sx={{
            fontSize: { xs: "32px" },
            color: "RGBA(5,15,0,0.74)",
          }}
        />
      ),
    },
    {
      name: "Capitals",
      summary: "Given a country - guess its capital city",
      description:
        "Select the region of the world, the number of questions, and the game mode you prefer. Multiple Choice: Given a country and 4 capitals from that region, select the correct capital. Type Answer: Given a country, type the correct capital for that country",
      link: "/capitals",
      icon: (
        <StarOutlined
          sx={{
            fontSize: { xs: "32px" },
            color: "RGBA(5,15,0,0.74)",
          }}
        />
      ),
    },
    {
      name: "HighLow",
      summary: "Two countries - pick high/low for a stat",
      description:
        "Select the region of the world, the number of questions, and the category (population, area or density) you prefer. Select whether the country on the bottom has a higher or lower value than the country on the top for the category you chose",
      link: "/highlow",
      icon: (
        <ImportExportOutlined
          sx={{
            fontSize: { xs: "32px" },
            color: "RGBA(5,15,0,0.74)",
          }}
        />
      ),
    },
    {
      name: "Lists",
      summary: "List countries for a given region and category",
      description:
        "Select the region of the world, and the category. Country category: List all countries for the region you chose. Other categories: List the top __ number of countries for the category. Ex. Europe Largest Areas requires you to list the 15 largest countries by land area in Europe. Finish before the time runs out. Sudden death - one incorrect country and the game ends!",
      link: "/lists",
      icon: (
        <FormatListNumberedOutlined
          sx={{
            fontSize: { xs: "32px" },
            color: "RGBA(5,15,0,0.74)",
          }}
        />
      ),
    },
    {
      name: "Maps",
      summary: "Find the location of countries on a map",
      description:
        "Select the region of the world, the number of questions. Find the location of a given country on a map. Use the region dropdown menu to zoom in on a particular region or subregion. Country will be filled in yellow on first click, and submitted on second click to ensure correct country was selected",
      link: "/maps",
      icon: (
        <MapOutlined
          sx={{
            fontSize: { xs: "32px" },
            color: "RGBA(5,15,0,0.74)",
          }}
        />
      ),
    },
    {
      name: "Lookup",
      summary: "Sortable table of data for every country",
      description:
        "A sortable lookup table of each country with a variety of data such as flags, capitals, regions, populations, areas and densities. Can Select a particular region from the dropdown menu, and sort/rank countries by clicking on a column header",
      link: "/lookup",
      icon: (
        <TravelExploreOutlined
          sx={{
            fontSize: { xs: "32px" },
            color: "RGBA(5,15,0,0.74)",
          }}
        />
      ),
    },
  ];
  const [expanded, setExpanded] = useState("panel0");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box
      sx={{
        width: { xs: "90%", sm: "70%", md: "50%", lg: "40%" },
        margin: "auto",
      }}
    >
      {games.map((game, idx) => {
        return (
          <Accordion
            elevation={10}
            key={idx}
            expanded={expanded === `panel${idx}`}
            onChange={handleChange(`panel${idx}`)}
          >
            <AccordionSummary
              sx={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                height: "42px",
              }}
              expandIcon={<ExpandMore />}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                {game.icon}
              </Box>
              <Typography
                variant="overline"
                sx={{
                  margin: "auto",
                  fontWeight: { xs: "500", md: "700" },
                  fontSize: { xs: "18px", sm: "22px" },
                  color: "RGBA(5,15,0,0.74)",

                  textAlign: "center",
                }}
              >
                {game.name}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: "background.default" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  margin: "auto",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: "12px",
                      color: "text.disabled",
                      textAlign: "center",
                      width: "90%",
                    }}
                  >
                    {game.description}
                  </Typography>
                </Box>

                <Link to={game.link} className={classes.link}>
                  <PlayCircleOutline
                    sx={{ fontSize: "32px", color: "RGBA(5,15,0,0.74)" }}
                  />
                </Link>
              </Box>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  );
};

export default Help;
